import React from 'react'
import isEmpty from 'lodash-es/isEmpty'
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'

import { IMatchEvent, IPlayer, IMatch } from 'protos'

import Grid from '@material-ui/core/Grid'
import Grow from '@material-ui/core/Grow'

import TimelineItem from 'components/TimelineItem'

import TimelineEmptyState from './TimelineEmptyState'

interface Props {
  match: IMatch
  events: IMatchEvent[]
  players: { [k: string]: IPlayer }
  onClickEvent?: (match: IMatch, player: IPlayer) => void,
}

type State = {
  events: Array<IMatchEvent & { shouldAnimate: boolean }>
}

const styles = (theme: Theme) => createStyles({
  root: {
    minHeight: 150,
    position: 'relative',
  },
  line: {
    position: 'absolute',
    left: '50%',
    top: '0',
    bottom: '0',
    width: 1,
    backgroundColor: theme.palette.divider,
  },
  event: {
    margin: `${theme.spacing() * 2}px 0`,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

class Timeline extends React.Component<InjectedProps, State> {
  constructor(props: InjectedProps) {
    super(props)

    this.state = { events: [] }
  }

  render() {
    const { events } = this.state
    const { classes, onClickEvent } = this.props

    if (isEmpty(events)) {
      return (
        <TimelineEmptyState />
      )
    }

    return (
      <Grid className={classes.root} direction="column-reverse" container>
        <div className={classes.line} />
        {
          events.map((event) => {
            const { players, match } = this.props
            const player = event.playerId ? players[event.playerId] : undefined
            const reverse = !!(match.awayTeam && match.awayTeam.teamId === event.teamId)

            let jersey
            if (!!player) {
              jersey = player.jersey
            } else if (event.teamId && !reverse && match.homeTeam) {
              jersey = match.homeTeam.jersey
            } else if (event.teamId && reverse && match.awayTeam) {
              jersey = match.awayTeam.jersey
            }

            const timelineItem = (
              <Grid key={`grid-${event.eventId}`} item className={classes.event}>
                <TimelineItem
                  type={event.type}
                  name={player && player.name}
                  clock={event.clock}
                  value={event.displayValue}
                  jersey={jersey}
                  reverse={reverse}
                  onClick={onClickEvent && player && (() => onClickEvent(match, player))}
                  timestamp={event.timestamp}
                />
              </Grid>
            )

            return event.shouldAnimate
              ? (
                <Grow key={`slide-${event.eventId}`} in>
                  {timelineItem}
                </Grow>
              )
              : timelineItem
          })
        }
      </Grid>
    )
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.events) {
      const events = props.events.map((propEvent) => {
        const hasEvents = !!state.events.length
        const isNewEvent = !state.events.some((stateEvent) => stateEvent.eventId === propEvent.eventId)
        const shouldAnimate = hasEvents && isNewEvent

        return { ...propEvent, shouldAnimate }
      })

      return { ...state, events }
    }

    return null
  }
}

export default withStyles(styles)(Timeline)
